import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useMe } from "@/context/MeContext";
import { errMsg, publicGet, useApi } from "@/lib/api";

export function AdminSettings() {
  const api = useApi();
  const { config } = useMe();
  const [s, setS] = useState(null);
  useEffect(() => { api("get", "/admin/settings").then((d) => setS({ ...d, categoriesText: d.categories.join(", ") })).catch(() => {}); }, [api]);
  if (!s) return <p className="text-slate-500">Caricamento…</p>;
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const setAff = (i, k, v) => setS({ ...s, affiliates: s.affiliates.map((a, j) => (j === i ? { ...a, [k]: v } : a)) });

  const save = async () => {
    try {
      await api("put", "/admin/settings", {
        iban: s.iban, holder: s.holder, bank: s.bank, admin_phone: s.admin_phone, vat_rate: parseFloat(s.vat_rate),
        categories: s.categoriesText.split(",").map((c) => c.trim()).filter(Boolean),
        affiliates: s.affiliates.filter((a) => a.domain && a.param),
        status_prices: { gold: parseFloat(s.status_prices?.gold || 50), diamond: parseFloat(s.status_prices?.diamond || 100) },
        google_site_verification: (s.google_site_verification || "").replace(/.*content=["']([^"']+)["'].*/, "$1").trim(),
      });
      Object.assign(config, await publicGet("/public/config"));
      toast.success("Impostazioni salvate");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="max-w-3xl space-y-6" data-testid="admin-settings">
      <div className="grid gap-4 sm:grid-cols-2">
        {[["holder", "Intestatario conto"], ["iban", "IBAN del club"], ["bank", "Banca (facoltativo)"], ["admin_phone", "Cellulare Admin per SMS ordini"], ["vat_rate", "Aliquota IVA (%)"]].map(([k, l]) => (
          <div key={k}><Label className="text-xs text-slate-400">{l}</Label><Input data-testid={`settings-${k}`} value={s[k]} onChange={set(k)} className="mt-1 bg-[#1C1F2C]" /></div>
        ))}
      </div>
      <div><Label className="text-xs text-slate-400">Codice verifica Google Search Console (meta tag google-site-verification)</Label><Input data-testid="settings-gsv" value={s.google_site_verification || ""} onChange={set("google_site_verification")} placeholder="es. AbC123… oppure incolla tutto il meta tag" className="mt-1 bg-[#1C1F2C]" />
        <p className="mt-1 text-xs text-slate-500">Sitemap da inviare a Search Console: {window.location.origin}/api/sitemap.xml</p></div>
      <div><Label className="text-xs text-slate-400">Categorie Marketplace (separate da virgola)</Label><Input data-testid="settings-categories" value={s.categoriesText} onChange={set("categoriesText")} className="mt-1 bg-[#1C1F2C]" /></div>
      <div className="grid gap-4 sm:grid-cols-2">
        {["gold", "diamond"].map((l) => (
          <div key={l}><Label className="text-xs text-slate-400">Prezzo acquisto status {l === "gold" ? "Gold" : "Diamond"} (€)</Label>
            <Input data-testid={`settings-status-price-${l}`} type="number" value={s.status_prices?.[l] ?? ""} onChange={(e) => setS({ ...s, status_prices: { ...s.status_prices, [l]: e.target.value } })} className="mt-1 bg-[#1C1F2C]" /></div>
        ))}
      </div>
      <div className="space-y-2">
        <Label className="text-xs text-slate-400">Codici affiliato per negozio (es. dominio amazon.it · parametro tag=tuocodice-21)</Label>
        {s.affiliates.map((a, i) => (
          <div key={i} className="flex gap-2">
            <Input data-testid={`aff-domain-${i}`} placeholder="amazon.it" value={a.domain} onChange={(e) => setAff(i, "domain", e.target.value)} className="bg-[#1C1F2C]" />
            <Input data-testid={`aff-param-${i}`} placeholder="tag=codice-21" value={a.param} onChange={(e) => setAff(i, "param", e.target.value)} className="bg-[#1C1F2C]" />
            <button onClick={() => setS({ ...s, affiliates: s.affiliates.filter((_, j) => j !== i) })} className="px-2 text-red-400">✕</button>
          </div>
        ))}
        <button data-testid="aff-add" onClick={() => setS({ ...s, affiliates: [...s.affiliates, { domain: "", param: "" }] })} className="text-sm text-amber-400 hover:underline">+ Aggiungi negozio</button>
      </div>
      <button data-testid="settings-save" onClick={save} className="rounded-full bg-amber-500 px-6 py-2 font-semibold text-black hover:bg-amber-400">Salva impostazioni</button>
    </div>
  );
}
